// @ts-nocheck
import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/client/react'
import useWindowScrollPosition from 'helpers/useWindowScrollPosition'

import { Container } from 'js/components/Grid'
import PageHeader from 'js/components/PageHeader/PageHeader'
import Section from 'js/components/Section/Section'
import FeedView from 'js/page/Widget/components/Feed/FeedView'

import { NEWS_LIST_WRAPPER } from './List.queries'

// First load data, otherwise useWindowScrollPosition and FeedView won't work properly
const ListWrapper = () => {
    const { data, loading } = useQuery<any>(NEWS_LIST_WRAPPER)

    if (loading) {
        return null
    }
    return <List data={data} />
}

const List = ({ data }) => {
    const { viewer, site } = data

    const { t } = useTranslation()

    const settings = {
        showTagFilter: site?.pageTagFilters.showAllTagCategories,
        showTagCategories: site?.pageTagFilters.showTagCategories,
        typeFilter: ['news'],
        sortBy: 'timePublished',
        sortDirection: 'desc',
        itemView: 'tile',
        itemCount: 3,
    }

    useWindowScrollPosition('news')

    return (
        <>
            <PageHeader
                title={t('entity-news.name', { count: 2 })}
                canCreate={viewer?.canWriteToContainer}
                createLink="/news/add"
                createLabel={t('entity-news.create')}
            />
            <Section>
                <Container>
                    <FeedView guid="news" settings={settings} />
                </Container>
            </Section>
        </>
    )
}

export default ListWrapper
